import mobileLogoLines from '../images/mobile-lines.png';

const NewLoginScreenStyles = (theme) => ({

  main: {
    width: '100%',
    height: '100vh',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundImage: theme.palette.login.background.backgroundImage,
    overflowY: 'auto',
    backgroundColor: theme.palette.login.background.backgroundColor,
    position: 'fixed',
  },

  header: {
    backgroundColor: theme.palette.login.background.backgroundColor,
    boxShadow: 'none',
    borderBottom: '1px solid #139a53',
    '@media (min-width:320px) and (max-width:480px)': {
      borderBottom: 'none',
    },
  },
  title: {
    flexGrow: 1,
  },

  headerLogo: {
    height: '60px',
    margin: '15px 0',
    '@media (min-width:320px) and (max-width:480px)': {
      display: 'none',
    },
  },

  footerLogo: {
    height: '30px',
    margin: '15px auto',
    display: 'none',
    '@media (min-width:320px) and (max-width:480px)': {
      display: 'block',
    },
  },

  mainLogin: {
    height: 'calc(100% - 154px)',

    '@media (min-width:320px) and (max-width:480px)': {
      height: 'calc(100% - 148px)',
    },
    '@media (min-width:480px)': {},
    '@media (min-width:768px)': {
      // margin: '20px 0'
    },
    '@media (min-width:1024px)': {},
    '@media (min-width:1200px)': {},
  },

  loginLeft: {
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    boxSizing: 'border-box',

    '@media (min-width:768px)': {
      marginTop: '20px',
    },

    '& img': {
      height: '100vh',
      '@media (min-width:1500px) and (max-width:2500px)': {
        objectFit: 'cover',
      },
    },
    '& .rightLogo': {
      display: 'flex',
      // justifyContent: 'center',
      '@media (max-width:768px)': {
        justifyContent: 'center',
        marginTop: '20px',
      },
      '& img': {
        width: 165,
        height: 165,
      },
      '& div': {
        paddingLeft: 20,
        '& > span': {
          color: '#139a53',
          fontSize: 30,
          // fontWeight: 'bold',
          transform: 'scaleY(0.9)',
          display: 'inline-block',
          lineHeight: 1,
        },
      },
      '& p': {
        fontWeight: 700,
        margin: 0,
        fontSize: 45,
        color: theme.palette.text.primary,
        '& span': {
          fontWeight: 'normal',
          fontSize: 43,
          display: 'inline-block',
          marginLeft: -6,
        },
      },
      '@media (min-width:768px) and (max-width:992px)': {

        '& img': {
          width: 110,
          height: 'auto',
          paddingTop: 0,
        },
        '& p': {
          fontSize: 37,
          '& span': {
            fontSize: '40px !important',
          },
        },
        '& div': {
          '& > span': {
            fontSize: '35px !important',
          },
        },
      },
      // '@media (min-width:1500px) and (max-width:2500px)': {
      //   '& img': {
      //     width: 264,
      //     marginTop: -5,
      //   },
      //   '& p': {
      //     fontSize: 65,
      //     '& span': {
      //       fontSize: '57px !important',
      //       marginLeft: '-8px !important',
      //     },
      //   },
      //   '& div': {
      //     '& > span': {
      //       fontSize: '57px !important',
      //     },
      //   },
      // },
      // '@media (min-width:2501px) and (max-width:3800px)': {
      //   marginLeft: 40,
      //   '& img': {
      //     width: 400,
      //   },
      //   '& p': {
      //     fontSize: 124,
      //     '& span': {
      //       fontSize: '114px !important',
      //       marginLeft: '-8px !important',
      //     },
      //   },
      //   '& div': {
      //     paddingLeft: '40px !important',
      //     '& > span': {
      //       fontSize: '104px !important',
      //     },
      //   },
      // },
    },

    '& .heading': {
      fontSize: '50px',
      color: theme.palette.text.primary,
    },
    '@media (max-width: 1920px)': {
      marginTop: '0',
    },
    '@media (min-width: 2500px)': {
      minHeight: '100vh',
    },
    '@media (min-width: 3800px)': {
      minHeight: '100vh',
    },
    '@media (max-width:767px)': {
      display: 'none',
    },
    '@media (min-width:768px) and (max-width:1200px)': {
      width: '50%',
    },
    '@media (min-width: 1301px) and (max-width:1400px)': {
      width: 'calc(100% - 600px)',
    },
  },

  loginRightMain: {
    display: 'flex',
    '@media (min-width:320px) and (max-width:480px)': {
      display: 'block',
    },

  },
  loginRight: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    overflow: 'hidden',
    boxSizing: 'border-box',
    fontFamily: 'robotoblack, sans-serif',
    '@media (min-width:320px) and (max-width:480px)': {
      width: '100%',
      justifyContent: 'space-around',
      display: 'block',
      height: '100vh',
    },

    '@media (min-width:481px) and (max-width:767px)': {
      width: '100%',
      // padding: '30px 30px 50px 30px !important',
      justifyContent: 'space-around',
      // overflow: 'auto',
      display: 'block',
      height: '100vh',
    },

    '& .form-set': {
      overflowY: 'auto',
      overflowX: 'hidden',
    },
    '& .loginForm': {
      width: '82%',
      '@media (max-width:425px)': {
        width: '100%',
      },
    },
  },

  mobileHeading: {
    color: theme.palette.text.primary,
    textAlign: 'center',
    fontSize: '20px',
    transform: 'scale(1.5)',
    marginTop: '0',
  },

  loginCredentials: {

    '& .MuiFilledInput-root': {
      borderRadius: '4px',
    },
    '& .MuiFilledInput-input:autofill': {
      boxShadow: '0 0 0 100px transparent inset !important',

    },
    '& .MuiFilledInput-input:-webkit-autofill': {
      boxShadow: `0 0 0 100px ${theme.palette.inputBackgroundColor.backgroundColor} inset`,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '2px solid transparent !important',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):after': {
      borderBottom: '2px solid transparent !important',
    },
    '& .MuiFilledInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: 'none !important',
    },
    '& .MuiFilledInput-underline:hover:not(.Mui-disabled):after': {
      borderBottom: 'none !important',
    },

    '& label': {
      color: `${theme.palette.text.primary} !important`,
      fontWeight: 'bold',
      fontSize: 16,
      paddingBottom: 10,
      background: 'none !important',
      paddingLeft: '5px !important',
      paddingRight: '0 !important',
      top: '0px !important',
      '&.Mui-focused': {
        color: `${theme.palette.text.primary} !important`,
        background: 'none',
        top: '0px !important',
        fontSize: 12,
      },
      '& @media (min-width:1600px)': {
        fontSize: 16,
      },
    },
    '& div': {
      '& input': {
        borderRadius: '4px',
        marginLeft: 0,
        paddingLeft: 30,
        paddingRight: 30,
        // color: '#000',
        color: theme.palette.formPage.color,
        fontSize: '14px',
        fontWeight: 'bold',
        '& @media (min-width:1600px)': {
          fontSize: 16,
        },
      },
    },
    '& .MuiInput-underline:before': {
      borderBottom: '1px solid #000 !important',
      left: 0,
      '&.Mui-focused:before': {
        borderBottom: '1px solid #888  ',
      },
    },
    '& .MuiFilledInput-underline:before': {
      borderBottom: 'none !important',
      left: 0,
      '&.Mui-focused:before': {
        borderBottom: 'none',
      },
    },
    '& .MuiInput-underline:after': {
      borderBottom: '1px solid #000 !important',
      left: 25,
      '&.Mui-focused:after': {
        borderBottom: '1px solid #888 !important',
      },
    },
    '& .MuiFilledInput-underline:after': {
      borderBottom: 'none !important',
      left: 25,
      '&.Mui-focused:after': {
        borderBottom: 'none !important',
      },
    },
  },

  fieldIcon: {
    padding: '0px',
    color: theme.palette.login.iconColorPrimary,
  },
  error: {
    color: '#f00',
  },

  footer: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderTop: '1px solid #139a53',
    bottom: 0,
    top: 'auto',
    zIndex: 0,
    color: theme.palette.text.primary,
    '@media (min-width:320px) and (max-width:480px)': {
      borderTop: 'none',
    },
    '@media (max-width:420px)': {
      backgroundColor: theme.palette.login.background.backgroundColor,
    },

    '& span': {
      '@media (max-width:420px)': {
        display: 'block',
      },
    },
  },

  avatar: {
    width: '100%',
    height: '100%',
    borderRadius: 0,
    objectFit: 'cover',
  },
  h3: {
    color: 'currentColor',
    fontSize: 32,
    fontWeight: 400,
  },

  registerRight: {
    overflow: 'auto',
    padding: '50px 50px 0',
    justifyContent: 'flex-start',
    height: '100vh',
    minHeight: '100vh',
  },
  formLabel: {
    color: theme.palette.text.primary,
    width: 200,
    textAlign: 'right',
    fontSize: 16,
    float: 'left',
    marginRight: 20,
    lineHeight: '32px',
    marginBottom: 25,
  },
  formInput: {
    width: 'calc(100% - 0px)',
    float: 'left',
    '& label': {
      left: 10,
    },
    '& div': {
      '& input': {
        paddingLeft: 25,
      },
    },
  },
  changeAvatar: {
    fill: theme.palette.primary.contrastText,
    margin: '5px',
    fontSize: 17,
  },
  activeButton: {
    minHeight: 46,
    lineHeight: '46px',
    textAlign: 'center',
    padding: '0 40px',
    transition: 'box-shadow .45s',
    border: 0,
    color: '#fff',
    background: '#01BD5A',
    marginBottom: 5,
    borderRadius: '2px',
    textTransform: 'capitalize',
    minWidth: 'inherit',
    '& span': {
      fontSize: '18px',
    },
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.85)',
      '& img': {
        opacity: 0.85,
      },
    },
    '& img': {
      width: 23,
      marginLeft: 8,
    },
    '&:hover': {
      transition: 'box-shadow .45s',
      background: '#139a53',
      boxShadow: '0 8px 17px 0 rgba(0,0,0,.2), 0 6px 20px 0 rgba(0,0,0,.19)',
    },
    '@media (max-width:767px)': {
      marginTop: 15,
    },
  },
  marginBottom: {
    marginBottom: 30,
    position: 'relative',
    '@media (min-width: 1919px)': {
      marginBottom: 50,
    },
  },
  inputIcon: {
    color: theme.palette.text.primary,
    position: 'absolute',
    top: '1px',
    left: '-38px',
    borderBottom: 'solid 1px transparent',
    // borderBottom: 'none',
    lineHeight: '13px',
    '& svg': {
      color: theme.palette.text.primary,
      marginTop: 20,
      marginLeft: 39,
      position: 'relative',
      zIndex: 99,
      width: 20,
      height: 20,
    },
  },
  correctStatus: {
    position: 'absolute',
    right: 0,
    top: 35,
    display: 'none',
    '& svg': {
      color: '#0065f7',
    },
  },
  linkCss: {
    fontSize: 14,
    display: 'flex',
    justifyContent: 'flex-end',
    '& a': {
      color: '#888',
      fontSize: 14,
      '&:hover': {
        textDecoration: 'none',
      },
    },
  },
  forgotPassword: {
    '& a': {
      color: '#139a53',
      fontWeight: 'bold',
    },
    '@media (max-width:767px)': {
      justifyContent: 'center',
      marginBottom: 20,
    },
  },
  registerUser: {
    marginBottom: 20,
    justifyContent: 'space-between',
    alignItems: 'center',
    '& a': {
      marginLeft: 5,
      '& span': {
        color: '#139a53',
        fontWeight: 'bold',
      },
    },
    '@media (max-width:767px)': {
      flexDirection: 'column',
    },
    '@media (min-width:768px) and (max-width:1024px)': {
      justifyContent: 'center',
    },
  },
  loginUser: {
    justifyContent: 'center',
    '& button': {
      width: '100%',
    },
  },
  forgetPassword: {
    marginTop: 10,
    flexDirection: 'column',
    '& button': {
      width: '100%',
      marginBottom: 30,
    },
  },
  registerBtn: {
    marginTop: 0,
    marginBottom: 50,
  },
  loginLogo: {
    boxSizing: 'border-box',
    maxWidth: 160,
    // margin: '0 auto 30px',
    /* '@media (max-width:767px)':{
            display:'none'
        } */
  },
  mobileLogo: {
    display: 'none',
    '@media (max-width:767px)': {
      display: 'block',
      width: '100%',
      textAlign: 'center',
      marginBottom: 20,
      marginTop: 20,
    },
  },

  registerFields: {
    '& div': {
      '& input': {
        paddingRight: 0,
      },
    },
  },
  copyright: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: 'center',
    display: 'block',
    color: '#888',
    fontSize: 14,
    fontWeight: 'normal',
    padding: '10px 0',
    '@media (max-width:767px)': {
      position: 'static',
      fontSize: 14,
    },
  },
  registerFooter: {
    position: 'static',
  },
  registerButton: {
    color: '#888',
    fontSize: 14,
    '@media (max-width:767px)': {
      fontSize: 12,
      marginBottom: 10,
    },
    '@media (min-width:768px) and (max-width:1024px)': {
      marginBottom: 10,
    },
  },
  registerCredential: {
    width: '100%',
  },
  forgotPasswordLabel: {
    color: theme.palette.text.primary,
    width: 'auto',
    float: 'left',
    lineHeight: '20px',
    textAlign: 'justify',
    marginBottom: '40px',
    marginTop: 0,
    '& span': {
      color: '#139a53',
    },
    '@media (max-width:767px)': {
      marginTop: 30,
      textAlign: 'left',
      lineHeight: 'inherit',
      marginBottom: 20,
    },
  },
  phoneNumberType: {
    '& .react-tel-input': {
      width: 'auto',
      marginLeft: 25,
      marginTop: 30,
      // borderBottom: '1px solid #000',
      '& input': {
        border: 'none',
        width: '100%',
      },
      '& .flag-dropdown': {
        backgroundColor: 'transparent',
        border: 'none',
      },
    },

  },
  helpIconOnLogin: {
    color: theme.palette.login.iconColorPrimary,
    float: 'right',
    position: 'absolute',
    top: '16px',
    right: '40px',
    '& .loginPasswordHelpIcon': {
      position: 'absolute',
      background: '#000',
      // color: '#fff',
      color: theme.palette.text.primary,
      right: 6,
      padding: 10,
      width: 380,
      fontSize: 13,
      opacity: 0,
      top: 36,
      '& span': {
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        // borderBottom: '5px solid #000',
        borderBottom: 'none',
        position: 'absolute',
        zIndex: 999,
        top: -5,
        right: 5,
      },
    },
    '&:hover': {
      '& .loginPasswordHelpIcon': {
        opacity: 1,
      },
    },
  },
  tooltipClass: {
    marginRight: 25,
    font: 16,
  },
  phoneLabel: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    position: 'absolute',
    top: 15,
    left: 25,
    fontSize: 12,
    fontWeight: 'bold',
    color: '#000',
  },
  errorMessage: {
    fontSize: 12,
    color: '#f00',
    marginLeft: 28,
    left: '0 !important',
  },
  mobileBackgroundImage: {
    '@media (max-width:767px)': {
      background: `url(${mobileLogoLines})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left bottom',
      left: 10,
      top: 20,
      height: '100vh',
      position: 'fixed',
      width: 52,
      display: 'none',
      paddingTop: 140,
      '& img': {
        width: '100%',
        height: '100%',
      },
    },
    '@media (min-width:421px) and (max-width:767px)': {
      left: 10,
      paddingTop: 10,
      top: 20,
      height: '100vh',
      position: 'fixed',
      background: `url(${mobileLogoLines})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'left bottom',
      width: 52,
      display: 'none',
      '& img': {
        width: '100%',
        height: '100%',
      },
    },
  },
  fullWidth: {
    width: '100%',
  },
  alignLeft: {
    '& label': {
      left: 0,
    },
    '& input': {
      marginLeft: '0 !important',
    },
    '& .MuiFormHelperText-root.Mui-error': {
      marginLeft: '0 !important',
      color: '#f00 !important',
    },

  },
  titleAlign: {
    paddingLeft: 6,
    fontFamily: '"Roboto",Arial,Helvetica,sans-serif',
    color: theme.palette.text.primary,
    '& h2': {
      fontSize: '2rem !important',
      marginBottom: '0px',
      width: '100%',
    },

  },
  btn2: {
    background: '#292929',
    minHeight: '46px',
    textAlign: 'center',
    transition: 'box-shadow .45s',
    lineHeight: '46px',
    borderRadius: '2px',
    marginBottom: '5px',
    color: theme.palette.primary.contrastText,
    '&:hover': {
      background: theme.palette.modalHeaderBg.color,
      boxShadow: 'none',
      opacity: 0.8,
    },
  },
  methodsText: {
    margin: '10px 0',
    color: '#189b54',
    fontWeight: 700,
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.8,
    },
  },
  mailButton: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.modalHeaderBg.color,
    '&:hover': {
      background: theme.palette.modalHeaderBg.color,
      boxShadow: 'none',
      opacity: 0.8,
    },
  },
  commentIconSvg: {
    '& svg': {
      margin: '0px 5px',
    },
    '& .timer': {
      margin: '0px 5px',
    },
  },
  heightSet: {
    height: '77%',
    margin: 'auto',
  },
  methodsBorder: {
    background: ' #01BD5A',
    color: theme.palette.text.primary,
    margin: '20px 0px 0px',
    width: '100%',
    padding: 14,
    fontSize: 16,
    fontWeight: 600,
    '& a': {
      color: '#000',
    },
    '&:hover': {
      opacity: 0.8,
    },

  },
  alignResendButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    '& button': {
      marginLeft: 10,
    },
  },
  OTPScreen: {
    '& h2': {
      marginBottom: 0,
      padding: '20px 0',
      width: '100%',
      textAlign: 'center',
      color: theme.palette.text.primary,
    },
  },
  otpFormInput: {
    '& label': {
      left: 0,
    },
    '& div input': {
      paddingLeft: 0,
    },
  },
  inputPadLeft: {
    '& div input': {
      paddingLeft: 0,
    },
  },
});

export default NewLoginScreenStyles;
